import React, { useState } from "react";
import { deleteSkeduloJob } from "../services/services";
import CancelForm from "../components/forms/CancelForm/CancelForm";

export default function Cancel(props) {
  const { eligibilityConfig } = props;
  const [cancelSuccess, setCancelSuccess] = useState(false);
  const [textInputValue, setTextInputValue] = useState('');
  const [otherReasonInputValue, setOtherReasonInputValue] = useState('');
  const [checkboxValue, setCheckboxValue] = useState('');
  const [error, setError] = useState({ error: false, errorMessage: '' });
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const {
    baseUrl,
    customer,
    urlToRedirect,
    appointmentId,
    cancelCallback,
    closeCancelCallback
  } = eligibilityConfig;

  const cancelReasons = [
    "I will reschedule in the future",
    "I'm no longer interested",
    "I have a question, please contact me",
    "Other"
  ];
  const otherCancelReason = cancelReasons[cancelReasons.length - 1].toLocaleLowerCase();

  const handleCheckboxChange = (event) => {
    const checkboxValue = event.target.checked ? event.target.name : "";
    setCheckboxValue(checkboxValue);
    if (checkboxValue) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }

  const handleOtherInputChange = (event) => {
    const textValue = event.target.value ? event.target.value : "";
    setOtherReasonInputValue(textValue);
  };

  const handleInputChange = (event) => {
    const textValue = event.target.value;
    setTextInputValue(textValue);
  };

  const handleExit = () => {
    if (closeCancelCallback && window[closeCancelCallback]) window[closeCancelCallback]();
    return;
  };

  const handleCancel = async () => {
    setLoading(true);
    const appointmentCancelReason = checkboxValue.toLowerCase() === otherCancelReason ? otherReasonInputValue : checkboxValue;
    const response = await deleteSkeduloJob(baseUrl, customer, appointmentId, appointmentCancelReason, textInputValue)
      .catch(error => {
        console.error("error", error);
        setError({
          error: true,
          errorMessage: "Something went wrong"
        });
        setLoading(false);
      });
    if (response !== undefined) {
      setLoading(false);
      setCancelSuccess(true);
    }
  };

  const handleSuccessCancel = () => {
    window[cancelCallback]();
    window.location.replace(`${urlToRedirect}`);
  }

  return (
    <CancelForm
      error={error}
      loading={loading}
      checkboxValue={checkboxValue}
      cancelSuccess={cancelSuccess}
      buttonDisabled={buttonDisabled}
      textInputValue={textInputValue}
      otherReasonInputValue={otherReasonInputValue}
      handleExit={handleExit}
      handleCancel={handleCancel}
      handleInputChange={handleInputChange}
      handleSuccessCancel={handleSuccessCancel}
      handleCheckboxChange={handleCheckboxChange}
      handleOtherInputChange={handleOtherInputChange}
    />
  );
};
